import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Layout from '../../layouts/page';
import axios from 'axios';
import Backbtn from '../../components/backbtn';
import { config } from '../../config/index';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Submit from '../../components/button';
import FormField from '../../components/formfield';

const MemberCreate = () => {
  const estateID = localStorage.getItem('estateID');
  const [formData, setFormData] = useState({
    estate_id: estateID,
    name: '',
    email: '',
    phone_number: '',
    password: '',
    password_confirmation: '',
    status: '',
  });

  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    document.title = "Tuwe | Create Estate Member";
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
  
    // Trim whitespace from passwords
    // const trimmedPassword = formData.password.trim();
    // const trimmedConfirmPassword = formData.confirm_password.trim();
  
    // // Log passwords for debugging
    // console.log('Password:', trimmedPassword);
    // console.log('Confirm Password:', trimmedConfirmPassword);
    // console.log('Password Length:', trimmedPassword.length);
    // console.log('Confirm Password Length:', trimmedConfirmPassword.length);
  
    // if (trimmedPassword !== trimmedConfirmPassword) {
    //   toast.error("Passwords do not match");
    //   setLoading(false);
    //   return;
    // }
  
    const token = localStorage.getItem('auth_token');
  
    // Remove confirm_password from the data to be sent
    const { confirm_password, ...dataToSubmit } = formData;
  
    try {
      await axios.post(`${config.api_path}/estate-member`, dataToSubmit, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      });
      toast.success('Estate Member created successfully!');
      setTimeout(() => {
        navigate(-1);
      }, 2000);
  
      // Reset form after submission
      setFormData({
        estate_id: estateID,
        name: '',
        email: '',
        phone_number: '',
        password: '',
        password_confirmation: '',
        status: '',
      });
    } catch (error) {
      toast.error(error.response?.data?.message || 'Error submitting form');
      console.error('Error submitting form:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Layout>
      <div className="col-12 grid-margin">
        <div className="card">
          <div className="card-body">
            <h4>Create Estate Member</h4>
            <Backbtn />
            <form onSubmit={handleSubmit}>
              <div className="form-row">
                <FormField label="Full-Name" name="name" value={formData.name} onChange={handleInputChange} required />
                <FormField label="Email" name="email" type='email' value={formData.email} onChange={handleInputChange} required />
                <FormField label="Telephone Number" name="phone_number" type='tel' value={formData.phone_number} onChange={handleInputChange} required />
                <FormField label="Password" name="password"  value={formData.password} onChange={handleInputChange} required />
                <FormField label="Confirm Password" name="password_confirmation" value={formData.confirm_password} onChange={handleInputChange} required />
              </div>

              <Submit loading={loading} />
            </form>
            <ToastContainer />
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default MemberCreate;